var _style, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustrationBookLover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    transform: "scale(1)",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    xmlSpace: "preserve",
    className: "show_show__wrapper__graphic__5Waiy ",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "React") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#D1D3D4;}\n\t.st2{fill:#231F20;}\n\t.st3{fill:none;}\n\t.st4{fill:#3A6CED;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stool"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 37.8,
    y: 336.8,
    width: 424.1,
    height: 89.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M461.9,426.9H37.8c-0.4,0-0.7-0.3-0.8-0.8v-89.4c0-0.4,0.3-0.7,0.8-0.8h424.1c0.4,0,0.7,0.3,0.8,0.8v89.4 C462.6,426.6,462.3,426.9,461.9,426.9z M38.5,425.4h422.6v-87.9H38.5V425.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.2,336.8h429.2c2.2,0,4,1.8,4,4v6.5c0,2.2-1.8,4-4,4H35.2c-2.2,0-4-1.8-4-4v-6.5 C31.3,338.6,33.1,336.8,35.2,336.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M464.4,352H35.2c-2.6,0-4.7-2.1-4.7-4.7v-6.5c0-2.6,2.1-4.7,4.7-4.7h429.2c2.6,0,4.7,2.1,4.7,4.7v6.5 C469.1,349.9,467,352,464.4,352z M35.2,337.6c-1.8,0-3.2,1.4-3.2,3.2c0,0,0,0,0,0v6.5c0,1.8,1.4,3.2,3.2,3.2h429.2 c1.8,0,3.2-1.4,3.2-3.2v-6.5c0-1.8-1.4-3.2-3.2-3.2H35.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Books"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 67.4,
    y: 313.8,
    width: 132.8,
    height: 22.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M200.2,336.8H67.4c-0.4,0-0.8-0.3-0.8-0.8v-22.2c0-0.4,0.3-0.8,0.8-0.8h132.8c0.4,0,0.8,0.3,0.8,0.8V336 C200.9,336.4,200.6,336.8,200.2,336.8C200.2,336.8,200.2,336.8,200.2,336.8z M68.2,335.3h131.3v-20.7H68.1L68.2,335.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 127.8,
    y: 313.8,
    width: 72.4,
    height: 22.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M200.2,336.8h-72.4c-0.4,0-0.8-0.3-0.8-0.7c0,0,0,0,0-0.1v-22.2c0-0.4,0.3-0.7,0.8-0.8h72.4 c0.4,0,0.8,0.3,0.8,0.8V336C200.9,336.4,200.6,336.8,200.2,336.8z M128.5,335.3h70.9v-20.7h-70.9L128.5,335.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 90.7,
    y: 297.8,
    width: 107.6,
    height: 16.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M198.3,315H90.7c-0.4,0-0.8-0.3-0.8-0.8v-16.5c0-0.4,0.3-0.8,0.8-0.8h107.5c0.4,0,0.8,0.3,0.8,0.8v16.5 C199,314.6,198.7,315,198.3,315C198.3,315,198.3,315,198.3,315z M91.5,313.5h106.1v-15h-106L91.5,313.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 152.4,
    y: 297.8,
    width: 45.9,
    height: 16.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M198.3,315h-45.9c-0.4,0-0.7-0.3-0.8-0.7c0,0,0,0,0,0v-16.5c0-0.4,0.3-0.7,0.7-0.8c0,0,0,0,0,0h45.9 c0.4,0,0.8,0.3,0.8,0.8v16.5C199,314.6,198.7,315,198.3,315C198.3,315,198.3,315,198.3,315z M153.1,313.5h44.4v-15h-44.4 L153.1,313.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 75.5,
    y: 281.8,
    width: 107.5,
    height: 16.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M183.1,299H75.5c-0.4,0-0.8-0.3-0.8-0.8v-16.5c0-0.4,0.3-0.7,0.7-0.8c0,0,0,0,0,0h107.5c0.4,0,0.8,0.3,0.8,0.8 v16.5C183.8,298.6,183.5,299,183.1,299C183.1,299,183.1,299,183.1,299z M76.3,297.5h106.1v-15h-106L76.3,297.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 137.2,
    y: 281.8,
    width: 45.9,
    height: 16.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M183.1,299h-45.9c-0.4,0-0.7-0.3-0.8-0.8v-16.5c0-0.4,0.3-0.8,0.8-0.8h45.9c0.4,0,0.8,0.3,0.8,0.8v16.5 C183.8,298.6,183.5,299,183.1,299C183.1,299,183.1,299,183.1,299z M137.9,297.5h44.4v-15h-44.4V297.5z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    transform: "matrix(7.088889e-02 -0.9975 0.9975 7.088889e-02 -169.574 398.2471)",
    cx: 129,
    cy: 290.1,
    rx: 3.5,
    ry: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M129,294.4c-2.3,0-4.2-1.9-4.2-4.2s1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2c0,0,0,0,0,0 C133.2,292.5,131.3,294.4,129,294.4z M129,287.4c-1.5,0-2.7,1.2-2.7,2.7c0,1.5,1.2,2.7,2.7,2.7c1.5,0,2.7-1.2,2.7-2.7c0,0,0,0,0,0 C131.7,288.7,130.5,287.4,129,287.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M101.2,312.2c-0.4,0-0.7-0.3-0.8-0.7c0,0,0,0,0,0v-11.1c0-0.4,0.3-0.8,0.8-0.8s0.8,0.3,0.8,0.8v11.1 C102,311.8,101.6,312.2,101.2,312.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115.6,334.2c-0.4,0-0.8-0.3-0.8-0.8V316c0-0.4,0.3-0.8,0.8-0.8s0.8,0.3,0.8,0.8v17.4 C116.4,333.8,116,334.2,115.6,334.2C115.6,334.2,115.6,334.2,115.6,334.2z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "135.9,87.6 141.7,83.1 166.1,93.3 215.7,76.5 220.2,83.3 168.3,113.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "154.1,167.4 134,85.4 165.9,99.2 223.6,78.3 238.4,161.1 185.3,179.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M185.3,180.1c-0.1,0-0.2,0-0.3-0.1l-31.2-12c-0.2-0.1-0.4-0.3-0.5-0.5l-20-82c-0.1-0.4,0.1-0.8,0.5-0.9 c0.2,0,0.3,0,0.5,0L166,98.4l57.3-20.8c0.4-0.1,0.8,0.1,1,0.5c0,0,0,0.1,0,0.1l14.8,82.8c0.1,0.4-0.2,0.7-0.5,0.8l-53.1,18.3 C185.5,180.2,185.4,180.2,185.3,180.1z M154.7,166.9l30.6,11.7l52.2-18L223,79.3l-56.8,20.6c-0.2,0.1-0.4,0.1-0.6,0l-30.5-13.1 L154.7,166.9z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 165.9,
    y1: 99.2,
    x2: 180.7,
    y2: 175.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M180.7,175.8c-0.4,0-0.7-0.3-0.7-0.6l-14.7-75.9c-0.1-0.4,0.2-0.8,0.6-0.9c0,0,0,0,0,0 c0.4-0.1,0.8,0.2,0.9,0.6l14.7,75.9c0.1,0.4-0.2,0.8-0.6,0.9L180.7,175.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M201.9,194.1c0,0-5.9-9.2-5-11.6c0.7-2.4,1.1-4.9,1.4-7.3l-6.2,1.5c0,0-6.4-16.1-7.1-21.7s-12.7-0.4-13.1,3.9 s-0.6,15.5,2.8,21.9s13.1,21.9,13.1,21.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M187.7,203.4c-0.3,0-0.5-0.1-0.6-0.4c-0.1-0.1-9.7-15.6-13.1-22s-3.4-17.4-2.9-22.3c0.4-3.4,6.4-6.9,10.6-7 c2.3,0,3.8,1.1,4.1,3.1c0.6,4.8,5.6,17.9,6.8,20.9l5.6-1.3c0.2-0.1,0.5,0,0.7,0.2c0.2,0.2,0.3,0.4,0.2,0.6 c-0.2,2.5-0.7,5.1-1.4,7.5c-0.4,1.3,2.1,6.5,4.9,10.9c0.2,0.3,0.1,0.8-0.2,1c-0.3,0.2-0.8,0.1-1-0.2c-1-1.6-6-9.6-5.1-12.2 c0.6-2,1-4,1.2-6.1l-5.2,1.2c-0.4,0.1-0.7-0.1-0.9-0.4c-0.3-0.7-6.5-16.3-7.1-21.9c-0.1-0.4-0.2-1.8-2.6-1.8 c-3.6,0-8.8,3.2-9.1,5.6c-0.5,4.8-0.5,15.4,2.7,21.5c3.4,6.4,13,21.7,13.1,21.9c0.2,0.3,0.1,0.8-0.2,1 C188,203.3,187.9,203.4,187.7,203.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M385.3,203c-0.1,0-0.2,0-0.3,0c-0.4-0.2-0.6-0.6-0.4-1c0,0,0,0,0,0c6.2-15.6,2.4-35.1-9.2-47.3 c-0.6-0.6-1.2-1.2-1.8-1.9c-3.9-4-8.4-8.5-8.1-14.4c0.1-1.2,0.3-2.4,0.6-3.6c0.2-0.9,0.4-1.8,0.5-2.7c0.5-5.7-4.3-10.5-8.4-13.5 c-1-0.7-2-1.4-3-2.2l-0.1-0.1c-4.1-2.8-8.3-5.7-10.9-10.1c-3-5.2-3.5-11.1-3.9-16.8c-0.4-5-0.7-10.1-2.9-14.6 c-7.5-15.7-26.3-22.4-42-14.9c-2.1,1-4,2.2-5.8,3.6c-3.8,2.9-6.8,6.7-8.6,11.1c-2,4.9-2.5,10.4-2.7,15.7c-0.6,11.4-1.6,22.5-8,31.9 c-2,2.7-4.1,5.3-6.4,7.8c-4.2,4.7-8.2,9-9.4,14.7c-1.2,6.1,1,12.3,5.9,16.1c0.3,0.3,0.3,0.8,0.1,1.1c-0.2,0.3-0.7,0.3-1,0.1 c-5.3-4.2-7.8-11-6.4-17.6c1.3-6,5.4-10.6,9.7-15.4c2.3-2.4,4.4-4.9,6.3-7.6c6.1-9.1,7.2-19.9,7.7-31.1c0.3-5.4,0.7-11.1,2.8-16.2 c2-4.6,5.1-8.6,9.1-11.7c14.4-11.2,35.1-8.7,46.3,5.6c1.5,1.9,2.7,3.9,3.8,6.1c2.3,4.7,2.7,10,3,15.1c0.4,5.5,0.8,11.2,3.7,16.1 c2.4,4.1,6.5,6.9,10.4,9.6l0.1,0.1c1,0.7,2.1,1.4,3.1,2.2c4.4,3.3,9.6,8.5,9,14.9c-0.1,1-0.3,1.9-0.5,2.9c-0.3,1.1-0.5,2.2-0.6,3.4 c-0.2,5.3,4,9.5,7.7,13.3c0.6,0.6,1.3,1.3,1.9,1.9c12,12.6,15.9,32.7,9.5,48.9C385.8,202.8,385.6,203,385.3,203z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M268,156.2l-31.2,68.5l-30.4-34l-25.4,12c0,0,56,84.5,71.4,76.8s37.5-75.9,37.5-75.9L268,156.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M308.4,137.2c0,0-33.9,3.7-41.8,20.1s-6.2,92.4-6.2,92.4l125,13.4c0,0-3.2-62.5-9.1-90.2 S352.4,126.8,308.4,137.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "298.4,145.5 311,213.2 328.4,139  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M311,214L311,214c-0.4,0-0.7-0.3-0.7-0.6l-12.6-67.8c-0.1-0.4,0.2-0.8,0.6-0.9l30-6.5c0.3,0,0.5,0,0.7,0.2 c0.2,0.2,0.3,0.4,0.2,0.7l-17.4,74.3C311.7,213.8,311.4,214,311,214z M299.3,146l11.8,63.6l16.3-69.6L299.3,146z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M298.5,125.7l-0.1,19.8c0,0,2,11,14,7.7c7.2-2.1,13.1-7.3,16-14.2l-1.4-34.2c-0.1-1.4-5.9-6.9-5.7-19.5 c-8.6-0.1-16.7-3.7-22.4-10.1c0,0-5,7.5-7.2,9.9c-1.7,1.8-3.3,3.8-4.5,6c-2,3.8-2,8.6-1.9,12.8c0,5,0.5,10,1.5,14.9 C288.8,128,298.5,125.7,298.5,125.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M308.1,154.5c-2,0-3.9-0.5-5.5-1.5c-2.5-1.7-4.3-4.4-5-7.4c0,0,0-0.1,0-0.1l0.1-18.9c-2.6,0.4-5.3-0.1-7.6-1.4 c-2.2-1.5-3.6-3.8-4-6.3c-1-4.9-1.5-10-1.5-15c-0.1-4.1-0.2-9.1,1.9-13.1c1.3-2.2,2.8-4.3,4.6-6.1c2.1-2.3,7.1-9.8,7.1-9.8 c0.1-0.2,0.4-0.3,0.6-0.3c0.2,0,0.5,0.1,0.6,0.3c5.6,6.2,13.5,9.7,21.9,9.8c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5 c-0.2,6.1,1.4,12.1,4.6,17.3c0.5,0.6,0.8,1.4,1,2.2c0,0.2,1.4,34.2,1.4,34.2c0,0.1,0,0.2,0,0.3c-3,7.1-9,12.5-16.5,14.6 C311.2,154.3,309.7,154.5,308.1,154.5z M299.1,145.4c0.6,2.6,2.1,4.9,4.3,6.4c2.3,1.4,5.2,1.6,8.8,0.7c6.9-2,12.5-7,15.4-13.6 c-1.4-34.1-1.4-34.1-1.4-34.1c-0.2-0.5-0.5-1-0.8-1.4c-3.3-5.2-5-11.2-4.9-17.3c-8.2-0.3-15.9-3.7-21.6-9.6 c-2.1,3.2-4.3,6.2-6.7,9.2c-1.7,1.7-3.2,3.7-4.4,5.8c-2,3.7-1.9,8.3-1.8,12.4c0,4.9,0.5,9.9,1.5,14.7c0.3,2.2,1.6,4.1,3.4,5.4 c3.2,2,7.3,1.1,7.4,1.1c0.2-0.1,0.5,0,0.6,0.1c0.2,0.1,0.3,0.4,0.3,0.6L299.1,145.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M298.6,135.4c0,0,8,0.4,13.2-5s4.4-10.7,4.4-10.7s-8.7,5.8-17.7,6L298.6,135.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M299,136.1h-0.4c-0.4,0-0.7-0.3-0.7-0.7l-0.1-9.7c0-0.4,0.3-0.7,0.7-0.8c8.7-0.2,17.2-5.8,17.3-5.9 c0.3-0.2,0.8-0.1,1,0.2c0.1,0.1,0.1,0.2,0.1,0.3c0,0.2,0.8,5.8-4.6,11.4C307.6,135.8,300.7,136.1,299,136.1z M299.3,126.4l0.1,8.2 c2-0.1,7.9-0.6,11.9-4.8c2.4-2.4,3.9-5.5,4.2-8.9C312.9,122.6,306.3,126,299.3,126.4L299.3,126.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M300.7,96.7c0,0-6.4,9.5-4.8,11.1s5.7,0.6,5.7,0.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M298.8,109.5c-1.3,0.1-2.5-0.3-3.5-1.2c-0.7-0.8-1-3.4,4.8-12.1c0.2-0.4,0.6-0.5,1-0.3c0.4,0.2,0.5,0.6,0.3,1 c0,0-0.1,0.1-0.1,0.1c-3.1,4.7-5.4,9.4-4.9,10.2c1,1.1,4,0.6,5,0.3c0.4-0.1,0.8,0.1,0.9,0.5c0,0,0,0,0,0c0.1,0.4-0.1,0.8-0.5,0.9 c0,0,0,0,0,0C300.8,109.3,299.8,109.5,298.8,109.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M294,113.1c0,0,5.7,8.4,15.7,0.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M301.3,117.7c-0.5,0-0.9,0-1.4-0.1c-2.7-0.4-5-1.9-6.6-4.1c-0.2-0.3-0.1-0.8,0.2-1c0.3-0.2,0.8-0.1,1,0.2 c1.4,1.8,3.4,3,5.6,3.4c2.8,0.4,5.8-0.7,9-3.3c0.3-0.3,0.8-0.2,1,0.1c0.3,0.3,0.2,0.8-0.1,1.1C307.1,116.5,304.2,117.7,301.3,117.7 z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 275.1,
    y1: 248.1,
    x2: 279.8,
    y2: 169.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M275.1,248.9L275.1,248.9c-0.5,0-0.8-0.4-0.8-0.8c0,0,0,0,0,0l4.7-78.4c0-0.4,0.4-0.7,0.8-0.7c0,0,0,0,0,0 c0.4,0,0.7,0.4,0.7,0.8c0,0,0,0,0,0l-4.7,78.4C275.8,248.5,275.5,248.8,275.1,248.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M287.3,347.6c-32.6,0-63.3-2.9-63.6-2.9l-1.1-0.1l-13.1-40.3v-0.2c-0.8-7.3-1.5-14.3,2.8-19.5 c3.8-4.7,11.4-7.4,23.6-8.6l36.7-7.5l1.1-22.4l92.6,10.3l0.3,1c3.5,10.5,6,21.2,7.4,32.2c2.6,21.5-0.8,36.6-10,44.9 C354.4,343.2,328.6,347.6,287.3,347.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M243.1,307.8c0,0-6-29-27.9-22.5S242,399.8,242,406.9s-18.6,28.5-18.6,28.5c5.3-0.3,10.6-0.8,15.9-1.6 c5.8-1.1,21.6-24.1,22.2-26.6S250.5,328.6,243.1,307.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M223.4,436.2c-0.3,0-0.5-0.2-0.7-0.4c-0.1-0.3-0.1-0.6,0.1-0.8c6.4-7.3,18.4-22.6,18.4-28 c0-1.6-3.2-10-7.2-20.7c-11.6-30.9-31.1-82.6-23.7-97.6c0.9-1.9,2.5-3.4,4.5-4c5.7-1.7,10.9-1.2,15.4,1.5 c10,5.9,13.2,20.4,13.5,21.5c7.1,20.1,19.1,96.6,18.4,99.8c-0.5,2.3-16.5,26-22.8,27.1C234.1,435.4,228.8,435.9,223.4,436.2 L223.4,436.2z M221.4,285.1c-2,0-4.1,0.3-6,0.9c-1.6,0.5-2.9,1.7-3.6,3.3c-7.2,14.5,12.9,67.8,23.7,96.4 c4.8,12.7,7.3,19.4,7.3,21.2c0,6.3-13.5,22.8-17.7,27.6c4.7-0.3,9.4-0.8,14-1.5c5.3-1,21.1-23.7,21.6-26c0.3-2.1-10.8-77.9-18.3-99 V308c0-0.1-3.2-14.9-12.8-20.6C227.1,285.9,224.3,285.1,221.4,285.1L221.4,285.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M232.1,448.3c-0.8,0-1.6,0-2.4,0c-6.1-0.3-13.4-1.9-15.7-5.6c-0.9-1.4-1-3.1-0.3-4.6c2.4-5.6,8.3-6.1,8.5-6.1 s12-0.7,17.1-1.8c2.9-0.6,12.9-12.6,20.8-23.9l1.9-2.7l1,3.2c2.2,7.6,3.9,15.2,5.1,23c2.3,14.1,1.6,14.5,0.5,15 c-0.7,0.3-2.1,0.5-7.4,0.9l-1.9,0.1h-0.2c-1.9,0-2.8-1.7-3.2-3.6c-1.5,1.4-3.2,2.5-5.1,3.3C247.4,446.9,239.3,448.3,232.1,448.3 L232.1,448.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M293.5,407.3c0,0-9.5-93.9-13.9-111.4s-29.6-23-37.3-1.8s30.3,104.5,27.4,113.2s-13.9,25.9-13.9,25.9 s11.7,5.8,20.1,0S293.5,407.3,293.5,407.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M267,436.6c-4-0.1-7.9-1-11.5-2.7c-0.2-0.1-0.3-0.3-0.4-0.5c-0.1-0.2,0-0.4,0.1-0.6 c0.1-0.2,10.9-17.2,13.8-25.8c1-3.1-4.3-18.7-10-35.2c-9.9-28.9-22.2-64.8-17.4-78.1c3.4-9.3,10.6-14.6,19.4-14.2 c9.3,0.6,17.1,7.1,19.3,16.1c4.4,17.4,13.8,110.6,13.9,111.5c0,0.1,0,0.3-0.1,0.4c-0.4,0.8-9.3,20.4-17.8,26.2 C273.6,435.7,270.3,436.7,267,436.6z M257,432.9c2.7,1.1,11.8,4.4,18.6-0.3c7.7-5.4,16.3-23.4,17.2-25.5 c-0.5-4.9-9.6-94.2-13.8-111.1c-2.1-8.4-9.3-14.4-17.9-15c-8.1-0.4-14.8,4.5-17.9,13.2c-4.6,12.8,8.1,49.9,17.4,77.1 c7.1,20.8,11.1,32.7,10,36.2C267.9,415.4,259.1,429.5,257,432.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M256.9,450.5c-8.9,0-11.4-1-12.5-1.7s-2.6-1.9-2.8-3.6c-0.2-2,1.1-3.5,2.8-5.2c0.4-0.5,0.9-1,1.3-1.5 c3.2-3.8,9.3-6.6,9.5-6.7l0.6-0.3l0.7,0.3c1.6,0.5,3.2,0.7,4.9,0.6c4-0.1,7.9-0.9,11.6-2.3c10.4-3.8,19-23.2,19-23.4l2.1-4.8 l1.1,5.1c2.7,13,3.6,26.3,2.8,39.6l-0.1,1.2l-1.2,0.3c-2.3,0.6-4.7,0.9-7.1,1.2c-0.3,0-0.5,0-0.8-0.1c-0.9-0.2-1.9-0.5-2.1-6.6 c-2.2,2.6-5.1,5.6-7.4,6.3C276.7,449.6,265.7,450.5,256.9,450.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M370,297.9c1.1,1.7,4.8,37.6,4.8,37.6s40.7,3.7,41.3,0.8s-20.8-10.1-20.8-10.1l-6.7-28.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M407.9,338.2c-3,0-7.2-0.1-12.7-0.4c-10.1-0.6-20.4-1.5-20.5-1.5c-0.4,0-0.6-0.3-0.7-0.7 c-1.4-13.6-3.9-35.7-4.7-37.3c-0.2-0.3-0.1-0.8,0.2-1c0.3-0.2,0.8-0.1,1,0.2c1.1,1.7,3.9,28.2,4.9,37.3c18.1,1.6,37.5,2.5,39.8,1.3 c-0.6-1.3-8.3-5.1-20.2-9.1c-0.2-0.1-0.4-0.3-0.5-0.5l-6.7-28.5c-0.1-0.4,0.2-0.8,0.6-0.9c0.4-0.1,0.8,0.2,0.9,0.6l6.6,28.1 c8.2,2.8,21.5,7.8,20.9,10.8C416.7,337.2,416.5,338.2,407.9,338.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M375.2,170.9L403,306.2l-38.3,1c0,0-13.3-71.7-14.1-82.5S375.2,170.9,375.2,170.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 290.3,
    cy: 94.9,
    r: 8.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M290.3,104.3h-0.4c-5.2-0.2-9.2-4.6-9-9.8c0.1-5.2,4.4-9.3,9.5-9.3c5.2,0.1,9.3,4.4,9.3,9.5c0,0.2,0,0.3,0,0.5 l0,0C299.5,100.3,295.3,104.3,290.3,104.3L290.3,104.3z M290.3,87c-4.4,0-7.9,3.5-7.9,7.9c0,4.4,3.5,7.9,7.9,7.9 c4.2,0,7.7-3.4,7.9-7.6l0,0c0.2-4.4-3.2-8-7.6-8.2c0,0,0,0,0,0H290.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M309.3,87.7c-4.4,0-7.9,3.5-7.9,7.9c0,4.4,3.5,7.9,7.9,7.9c4.2,0,7.7-3.4,7.9-7.6l0,0c0.2-4.4-3.2-8-7.6-8.2 L309.3,87.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M309.4,104.3H309c-5-0.1-9-4.2-8.9-9.3c0.1-5,4.2-9,9.3-8.9c5,0.1,9,4.2,8.9,9.3 C318.2,100.3,314.2,104.2,309.4,104.3L309.4,104.3z M309.4,88.5c-4,0.1-7.2,3.4-7.1,7.4s3.4,7.2,7.4,7.1s7.2-3.4,7.1-7.4 c-0.1-3.9-3.2-7-7.1-7.1H309.4z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 247.8,
    y1: 237.8,
    x2: 210.8,
    y2: 195.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M247.8,238.5c-0.2,0-0.4-0.1-0.6-0.3l-36.9-42.6c-0.3-0.3-0.2-0.8,0.1-1.1c0.3-0.3,0.8-0.2,1.1,0.1l37,42.6 c0.3,0.3,0.2,0.8-0.1,1c0,0,0,0,0,0C248.2,238.5,248,238.5,247.8,238.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "179.9,112.3 214.9,98.9 218.1,115 182.8,126.3  "
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    transform: "matrix(3.925982e-02 -0.9992 0.9992 3.925982e-02 184.6995 379.9613)",
    cx: 289.9,
    cy: 93.9,
    rx: 2,
    ry: 1.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    transform: "matrix(3.925982e-02 -0.9992 0.9992 3.925982e-02 202.2987 400.5667)",
    cx: 309.5,
    cy: 95.1,
    rx: 2,
    ry: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M317.9,96.1c1.8-0.1,17.5-1.1,18,5.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M336,102.6c-0.4,0-0.7-0.3-0.8-0.7c-0.5-6.2-16.6-5.1-17.2-5.1c-0.4,0.1-0.8-0.2-0.9-0.6 c-0.1-0.4,0.2-0.8,0.6-0.9c0,0,0.1,0,0.1,0c3-0.2,18.2-1,18.9,6.4C336.8,102.2,336.5,102.5,336,102.6L336,102.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M320,103c0.3-1.5,1.1-2.8,2.2-3.8c1.1-0.9,2.3-1.5,3.6-2c0.7-0.3,1.4-0.5,2.2-0.5c0.5,0.1,1.1,0.2,1.5,0.5 c1.2,0.5,2.1,1.4,2.6,2.6c0.3,1,0.4,2,0.2,3c-0.1,1.1-0.3,2.2-0.7,3.2c-1.6,4.3-6.5,6.5-10.8,4.8c0,0-0.1,0-0.1-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M323.9,112.2c-1.2,0-2.3-0.2-3.4-0.7c-0.4-0.1-0.6-0.6-0.5-1c0.1-0.4,0.6-0.6,1-0.5c0,0,0,0,0.1,0 c3.9,1.6,8.3-0.3,9.9-4.2c0,0,0-0.1,0-0.1c0.4-1,0.6-2,0.7-3c0.1-0.9,0.1-1.8-0.2-2.7c-0.5-1-1.3-1.8-2.3-2.2 c-0.4-0.2-0.8-0.4-1.2-0.4c-0.7,0-1.3,0.2-1.9,0.4c-1.2,0.4-2.4,1.1-3.4,1.9c-1,0.9-1.7,2.1-2,3.4c-0.1,0.4-0.5,0.7-0.9,0.6 c-0.4-0.1-0.7-0.5-0.6-0.9c0,0,0,0,0,0c0.3-1.6,1.2-3.1,2.5-4.2c1.2-0.9,2.5-1.6,3.9-2.1c0.8-0.4,1.7-0.6,2.5-0.5 c0.6,0.1,1.2,0.3,1.8,0.6c1.3,0.6,2.4,1.7,3,3c0.4,1.1,0.5,2.2,0.3,3.4c-0.1,1.2-0.3,2.3-0.8,3.4c-0.9,2.3-2.6,4.1-4.9,5.1 C326.4,112,325.2,112.3,323.9,112.2z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 364.1,
    y1: 304,
    x2: 341.5,
    y2: 166.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M364.1,304.7c-0.4,0-0.7-0.3-0.7-0.6l-22.6-137.7c-0.1-0.4,0.2-0.8,0.6-0.9c0.4-0.1,0.8,0.2,0.9,0.6 c0,0,0,0,0,0l22.5,137.7c0.1,0.4-0.2,0.8-0.6,0.9L364.1,304.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M296.4,270.9c-0.1,0-0.2,0-0.3-0.1c-8.9-4-21.3-1.1-21.9-0.9c-0.4,0.1-0.8-0.2-0.9-0.6s0.2-0.8,0.6-0.9 c0.5-0.1,13.4-3.2,22.8,1c0.4,0.2,0.5,0.6,0.4,1c0,0,0,0,0,0C296.9,270.7,296.7,270.9,296.4,270.9z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 325.3,
    y1: 233.2,
    x2: 344,
    y2: 244.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M344,244.8c-0.1,0-0.3,0-0.4-0.1l-18.7-10.9c-0.4-0.2-0.5-0.7-0.3-1c0.2-0.4,0.7-0.5,1-0.3l18.7,10.9 c0.4,0.2,0.5,0.7,0.3,1C344.5,244.7,344.3,244.8,344,244.8L344,244.8z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 294.5,
    y1: 228.5,
    x2: 283.2,
    y2: 237.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M283.2,238.3c-0.4,0-0.8-0.3-0.8-0.7c0-0.2,0.1-0.5,0.3-0.6l11.2-9c0.3-0.3,0.8-0.2,1.1,0.1 c0.3,0.3,0.2,0.8-0.1,1.1l-11.2,9C283.6,238.2,283.4,238.3,283.2,238.3z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M146.4,391.3c3.6-3.2,7.6-5.8,11.9-7.8c0.4,12.7-4.8,24.5-9.6,32.5h-15.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M148.7,416.7h-15.5c-0.4,0-0.8-0.3-0.8-0.8s0.3-0.8,0.8-0.8h15.1c4.3-7.4,9.3-18.5,9.3-30.6 c-3.9,1.9-7.5,4.3-10.7,7.2c-0.3,0.3-0.8,0.2-1.1-0.1s-0.2-0.8,0.1-1.1c3.6-3.2,7.7-5.9,12.1-7.9c0.4-0.1,0.8,0,1,0.4 c0,0.1,0,0.2,0,0.2c0.4,13.1-5.1,25.1-9.7,32.9C149.2,416.6,149,416.7,148.7,416.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.2,394.7c3.8-19.9,19.4-32.4,19.4-32.4c2.9,9.4,3.9,19.2,2.8,29c-0.8,8.4-2.6,16.7-5.4,24.7h-16.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M141,416.7h-16.7c-0.4,0-0.8-0.3-0.8-0.8s0.3-0.8,0.8-0.8l0,0h16.2c2.6-7.8,4.4-15.8,5.2-24 c1-9.3,0.1-18.7-2.5-27.6c-3.3,2.9-15.1,14.5-18.3,31.3c0,0.4-0.4,0.7-0.8,0.7c-0.4,0-0.7-0.4-0.7-0.8c0,0,0-0.1,0-0.1 c3.8-20,19.5-32.8,19.7-32.9c0.2-0.2,0.4-0.2,0.7-0.1c0.2,0.1,0.4,0.3,0.5,0.5c2.9,9.5,3.9,19.4,2.9,29.3 c-0.8,8.5-2.6,16.8-5.4,24.9C141.6,416.5,141.3,416.7,141,416.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115.9,416h14.8c0.1-4.4-0.9-11-5.6-19.6l-1-1.7c-8.6-14.5-16.4-14.3-16.4-14.3 C104.4,395.6,111.4,409.2,115.9,416z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M130.7,416.7h-14.8c-0.2,0-0.5-0.1-0.6-0.3c-4.5-6.9-11.7-20.6-8.3-36.2c0.1-0.3,0.4-0.6,0.7-0.6 c0.3,0,8.4,0,17.1,14.7c0.3,0.5,0.6,1.1,0.9,1.7c5,9,5.8,15.8,5.7,20C131.4,416.4,131.1,416.7,130.7,416.7z M116.3,415.2H130 c0-4-1-10.3-5.5-18.5l-0.9-1.6c-6.9-11.6-13.2-13.6-15.2-13.9C105.5,395.7,112,408.6,116.3,415.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "118.6,439.5 147.6,439.5 152.3,416 113.9,416  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M147.6,440.2h-29c-0.4,0-0.7-0.3-0.7-0.6l-4.7-23.5c0-0.2,0-0.4,0.2-0.6c0.1-0.2,0.4-0.3,0.6-0.3h38.4 c0.2,0,0.4,0.1,0.6,0.3c0.1,0.2,0.2,0.4,0.1,0.6l-4.7,23.5C148.3,439.9,148,440.2,147.6,440.2z M119.2,438.7H147l4.4-22h-36.5 L119.2,438.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationBookLover);
export default __webpack_public_path__ + "static/media/illustration-book-lover.6664e8bbe12cfb1a4bbb611fe4832194.svg";
export { ForwardRef as ReactComponent };